import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium" }
const _hoisted_3 = { class: "form-wrapper row drv-gap-4 drv-py-2" }
const _hoisted_4 = { class: "drv-color-n600" }

import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  IBaseRequestTsp,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestTsp',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const isDiasbled = computed<boolean>(() => {
  return props.disable || isLoading.value;
});

const isLoading = ref<boolean>(false);

const emit =
  __emit;

const EMPTY_MODEL = { type: EAuthTypes.REQUEST, username: "", password: "" };

const model = computed<IBaseRequestTsp>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IBaseRequestTsp) {
    emit("update:modelValue", value);
  },
});

const usernameModel = computed<string>({
  get() {
    return props.modelValue?.username ?? EMPTY_MODEL.username;
  },
  set(value: string) {
    model.value = { ...model.value, username: value };
  },
});

const passwordModel = computed<string>({
  get() {
    return props.modelValue?.password ?? EMPTY_MODEL.password;
  },
  set(value: string) {
    model.value = { ...model.value, password: value };
  },
});

const currentMethod = computed(() => {
  return props.platform.methods.find(
    (m) => m.authorityType === EAuthTypes.BASIC
  );
});

const nameControl = ref<typeof Input | null>(null);

const hasError = computed<boolean>(() => {
  return !usernameModel.value || nameControl.value?.hasError;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).REQUEST_TSP_SUBTITLE)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_d_input, {
        ref_key: "nameControl",
        ref: nameControl,
        class: "drv-form-control-adaptive",
        modelValue: usernameModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameModel).value = $event)),
        disable: isDiasbled.value,
        label: _ctx.$t(_unref(ETelematicsMessagesKeys).REQUEST_TSP_USERNAME_TITLE),
        "lazy-rules": "",
        rules: [
          _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
          _unref(maxLengthValidator)(
            100,
            _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
          ),
          _unref(minLengthValidator)(
            2,
            _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
          ),
        ]
      }, null, 8, ["modelValue", "disable", "label", "rules"]),
      _createVNode(_component_d_input, {
        class: "drv-form-control-adaptive",
        "label-slot": "",
        modelValue: passwordModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordModel).value = $event))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).REQUEST_TSP_PASSWORD_TITLE)) + " ", 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(_unref(ECommonMessages).OPTIONAL)), 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})